import * as _ from "lodash"

let globals = {}

export function mutateDataset(dataset, ruleset, newGlobals = {}) {
  globals = newGlobals
  const clonedDataset = _.cloneDeep(dataset)
  for (const dataKey in ruleset) {
    // assume for now that dataKey exists in dataset -- it should throw an exception if not
    let dataSetToOperateOn = clonedDataset[dataKey]
    const modifiersForData = ruleset[dataKey]

    applyOperators(dataSetToOperateOn, modifiersForData)
  }

  return clonedDataset
}

// Function to apply a single operation
function applyOperation(dataObj, operation) {
  const { condition, action, ...operationVals } = operation
  if (typeof condition !== "function" || condition(dataObj, globals)) {
    action(dataObj, operationVals)
  }
}

// Apply an array of operators
function applyOperators(dataObj, operators) {
  operators.forEach(operator => {
    applyOperation(dataObj, operator)
  })
}

let randomIndexCache = {}

export function randomizeAction(dataObj, { actions, id }) {
  // actions will be an array of modifiers
  // we want to pick one randomly, and then run the action inside
  let randomActionIndex

  if (_.has(randomIndexCache, id)) {
    randomActionIndex = randomIndexCache[id].value
  } else {
    randomActionIndex = Math.floor(Math.random() * actions.length)
    randomIndexCache[id] = {
      value: randomActionIndex,
      name: actions[randomActionIndex].name
    }
  }

  const randomAction = actions[randomActionIndex]

  if (
    typeof randomAction.condition !== "function" ||
    randomAction.condition(dataObj, globals)
  ) {
    if (randomAction.operator) {
      return applyOperation(dataObj, randomAction.operator)
    }

    return applyOperators(dataObj, randomAction.operators)
  }

  return dataObj
}

// Sequences a set of actions
// This is mainly replaced by oprerators property
export function sequenceAction(dataObj, { operators }) {
  return applyOperators(dataObj, operators)
}

// Iterates through a data object, applying the operators or operators onto each object found
export function iterateAction(
  dataObj,
  { attr = "", exceptKeys = [], operator, operators }
) {
  const newDataObjToIterate = _.get(dataObj, attr, dataObj)

  const mutatedData = Object.keys(newDataObjToIterate).reduce(
    (agg, dataKey) => {
      const dataItem = newDataObjToIterate[dataKey]

      // deal with exceptions
      if (exceptKeys.length > 0) {
        if (exceptKeys.includes(dataKey)) {
          // exception exists, so pass this!
          return {
            ...agg,
            [dataKey]: dataItem
          }
        }
      }

      const mutatedDataItem = operator
        ? applyOperation(dataItem, operator)
        : applyOperators(dataItem, operators)
      return {
        ...agg,
        [dataKey]: mutatedDataItem
      }
    },
    {}
  )

  return {
    ...dataObj,
    [attr]: mutatedData
  }
}

// Get the random picks as a json string
export function getRandomPicks() {
  return JSON.stringify(randomIndexCache)
}

// Set the random cache based on a JSON string
export function rehydrateRandomPicks(previousPicks) {
  randomIndexCache = JSON.parse(previousPicks)
}
